import { render, staticRenderFns } from "./ClientExpectations.vue?vue&type=template&id=6c38b016"
import script from "./ClientExpectations.vue?vue&type=script&lang=js"
export * from "./ClientExpectations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports